'use strict';
import * as $j_app$002eprelude$002e$002dApp$002dCurrencies$0024 from "./app.prelude.-App-Currencies$.js";
import * as $j_app$002eprelude$002e$002dApp$002dCurrency from "./app.prelude.-App-Currency.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppUserPrefs(locale, defaultCurrency) {
  this.Fn = null;
  this.XK = null;
  this.Fn = locale;
  this.XK = defaultCurrency;
}
export { $c_Lapp_data_AppUserPrefs as $c_Lapp_data_AppUserPrefs };
$p = $c_Lapp_data_AppUserPrefs.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppUserPrefs;
/** @constructor */
function $h_Lapp_data_AppUserPrefs() {
}
export { $h_Lapp_data_AppUserPrefs as $h_Lapp_data_AppUserPrefs };
$h_Lapp_data_AppUserPrefs.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppUserPrefs)) {
    var x = this.Fn;
    var x$2 = x$0.Fn;
    if ((x === x$2)) {
      var x$3 = this.XK;
      var x$4 = x$0.XK;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "AppUserPrefs";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Fn;
  }
  if ((n === 1)) {
    return this.XK;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "locale";
  }
  if ((n === 1)) {
    return "defaultCurrency";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.a5N = (function() {
  $j_app$002eprelude$002e$002dApp$002dCurrencies$0024.$m_Lapp_prelude_AppCurrencies$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lsquants_market_MoneyContext($j_app$002eprelude$002e$002dApp$002dCurrency.$m_Lapp_prelude_AppCurrency$().bMY().h(this.XK), $j_app$002eprelude$002e$002dApp$002dCurrencies$0024.$m_Lapp_prelude_AppCurrencies$().FH.u6, $j_app$002eprelude$002e$002dApp$002dCurrencies$0024.$m_Lapp_prelude_AppCurrencies$().FH.xP, $j_app$002eprelude$002e$002dApp$002dCurrencies$0024.$m_Lapp_prelude_AppCurrencies$().FH.Dm);
});
function $isArrayOf_Lapp_data_AppUserPrefs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ja)));
}
export { $isArrayOf_Lapp_data_AppUserPrefs as $isArrayOf_Lapp_data_AppUserPrefs };
var $d_Lapp_data_AppUserPrefs = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppUserPrefs, "app.data.AppUserPrefs", ({
  ja: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppUserPrefs as $d_Lapp_data_AppUserPrefs };
//# sourceMappingURL=app.data.-App-User-Prefs.js.map
